import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import LembretesService from './Service';

interface LembretesContextProps {
    data: any[];
    loading: boolean;
    error: boolean;
    reloadData: () => Promise<void>;
}

const LembretesContext = createContext<LembretesContextProps | undefined>(undefined);

export const useLembretesContext = () => {
    const context = useContext(LembretesContext);
    if (!context) {
        throw new Error('useLembretesContext must be used within a LembretesProvider');
    }
    return context;
};

export const LembretesProvider = ({ children }: { children: ReactNode }) => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const reloadData = async () => {
        try {
            setError(false);
            const result = await LembretesService.findAll().then((response) => response?.data || []);
            setData(result);
        } catch (error) {
            console.error('Error fetching lembretes:', error);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        reloadData();
    }, []);

    return <LembretesContext.Provider value={{ data, loading, error, reloadData }}>{children}</LembretesContext.Provider>;
};
